// src/sites/SchweizVerkaufen.jsx
//
// Regionsseite "Auto verkaufen in der Schweiz" (/auto-verkaufen-schweiz).
//
// WARUM ES DIESE SEITE GIBT:
// Die Startseite handelt von allem gleichzeitig: Ankauf, Zoll, Wunschauto,
// Kontakt, drei Laender. Google bewertet aber einzelne SEITEN, nicht
// Websites. Wer in Basel "Auto nach Deutschland verkaufen" sucht, soll eine
// Seite finden, die GENAU davon handelt.
//
// INHALTLICHE REGEL: Hier steht nichts, was nicht schon an anderer Stelle
// vom Inhaber bestaetigt wurde (Zollsaetze, eigene Abfertigung, Ablauf,
// Einzugsgebiet). Nichts ueber die Schweizer Seite des Papierkrams, solange
// er das nicht selbst geliefert hat.
import React, { useState } from "react";
import { useI18n } from "../I18nProvider";
import SeitenKopf from "./SeitenKopf";
import Overlay from "./Overlay";
import CarForm from "./CarForm";
import "./styles.css";

export default function SchweizVerkaufen() {
  const { t } = useI18n();

  // Eigenes Formular-Fenster. Die Startseite hat ihr eigenes; deren Zustand
  // liegt in AutoMAH und ist hier nicht erreichbar.
  const [formularOffen, setFormularOffen] = useState(false);

  const gruende = [1, 2, 3, 4].map((n) => ({
    titel: t(`chpage.why${n}_title`),
    text: t(`chpage.why${n}_text`),
  }));

  // Der Ablauf ist derselbe wie auf der Startseite. Bewusst aus dem
  // BESTEHENDEN Textblock gelesen statt abgetippt, damit beide Stellen nie
  // auseinanderlaufen.
  const schritte = [1, 2, 3, 4].map((n) => ({
    titel: t(`ablauf.s${n}_title`),
    text: t(`ablauf.s${n}_text`),
  }));

  const gebiete = t("chpage.area_list") || [];

  return (
    <>
      <SeitenKopf
        titel={t("chpage.meta_title")}
        beschreibung={t("chpage.meta_desc")}
        pfad="/auto-verkaufen-schweiz"
      />

      <section className="ch-hero">
        <div className="container">
          <h1>{t("chpage.h1")}</h1>
          <p className="ch-lead">{t("chpage.lead")}</p>
          <button className="btn btn-primary" onClick={() => setFormularOffen(true)}>
            {t("chpage.cta")}
          </button>
          <p className="ch-cta-hint">{t("chpage.cta_hint")}</p>
        </div>
      </section>

      <section className="services">
        <div className="container">
          <h2>{t("chpage.why_title")}</h2>
          <div className="ch-grund-liste">
            {gruende.map((g, i) => (
              <div className="ch-grund" key={i}>
                <h3>{g.titel}</h3>
                <p>{g.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Was der Verkaeufer selbst braucht, und was der Inhaber uebernimmt.
          Inhalt kommt WOERTLICH von Mohamed (25.08.2026): vom Schweizer
          braucht er nur Fahrzeugausweis und Kaufvertrag, Annullieren,
          Transport und Einfuhr macht er selbst. Nichts hinzugedichtet. */}
      <section className="ch-brauchen">
        <div className="container">
          <h2>{t("chpage.was_title")}</h2>
          <p className="ch-brauchen-lead">{t("chpage.was_lead")}</p>

          <div className="ch-spalten">
            <div className="ch-spalte ch-spalte-sie">
              {/* Ueberschrift sagt ehrlich, fuer WEN diese Liste gilt.
                  Fahrzeugausweis und Annullieren gibt es nur beim
                  Schweizer Fahrzeug; andere Faelle stehen unten. */}
              <h3>{t("chpage.sie_title")}</h3>
              <ul className="ch-punkte">
                {[1, 2].map((n) => (
                  <li key={n}>
                    <strong>{t(`chpage.was${n}_title`)}</strong>
                    <span>{t(`chpage.was${n}_text`)}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="ch-spalte ch-spalte-ich">
              <h3>{t("chpage.rest_title")}</h3>
              <ul className="ch-punkte ch-punkte-ich">
                {[1, 2, 3].map((n) => (
                  <li key={n}>
                    <strong>{t(`chpage.rest${n}_title`)}</strong>
                    <span>{t(`chpage.rest${n}_text`)}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Offene Tuer fuer alles, was kein Schweizer Fahrzeug ist.
              BEWUSST ohne Details: den Papierkram dieser Faelle hat der
              Inhaber noch nicht geschildert, und geraten wird hier nicht. */}
          <p className="ch-andere">{t("chpage.andere_text")}</p>
        </div>
      </section>

      <section className="ch-zoll">
        <div className="container">
          <h2>{t("chpage.zoll_title")}</h2>
          <p>{t("chpage.zoll_p1")}</p>
          <p>{t("chpage.zoll_p2")}</p>
          <p className="ch-hinweis">{t("chpage.zoll_hinweis")}</p>
        </div>
      </section>

      <section className="services">
        <div className="container">
          <h2>{t("chpage.ablauf_title")}</h2>
          <ol className="ch-schritte">
            {schritte.map((s, i) => (
              <li key={i}>
                <span className="ch-schritt-nr">{i + 1}</span>
                <div>
                  <h3>{s.titel}</h3>
                  <p>{s.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="ch-gebiet">
        <div className="container">
          <h2>{t("chpage.area_title")}</h2>
          <ul className="ch-gebiet-liste">
            {gebiete.map((g, i) => (
              <li key={i}>{g}</li>
            ))}
          </ul>
          <p className="ch-gebiet-lead">{t("chpage.area_lead")}</p>
        </div>
      </section>

      <section className="ch-schluss">
        <div className="container">
          <h2>{t("chpage.schluss_title")}</h2>
          <p>{t("chpage.schluss_text")}</p>
          <button className="btn btn-primary" onClick={() => setFormularOffen(true)}>
            {t("chpage.cta")}
          </button>
        </div>
      </section>

      <Overlay
        offen={formularOffen}
        titel={t("carform.service_purchase")}
        onSchliessen={() => setFormularOffen(false)}
      >
        <CarForm
          wunsch={
            formularOffen
              ? { typ: "purchase", auto: "", stempel: Date.now() }
              : null
          }
          onFertig={() => setFormularOffen(false)}
        />
      </Overlay>
    </>
  );
}
